<template>
  <div class="metadata-area">
    <div class="outer-wrapper">
      <div class="inner-wrapper">

        <div v-if="brandLogo" class="brand-logo">
          <img :src="require(`@/assets/images/detail/logo_${brandLogo}.png`)" :alt="`${brandLogo} 로고`">
        </div>

        <h1 class="main-title">{{ season.title }}</h1>

        <div class="metadata">
          <ul class="metadata-list">
            <li>{{ `시즌 ${ Number(seasonList.count) || '1' }개` }}</li>
            <li v-if="metaData.targetAge"><AgeGrade :target-age="metaData.targetAge" :section="kmrbCode" /></li>
            <li v-if="metaData.genreText">{{ metaData.genreText }}</li>
          </ul>
          <ul class="tag-list">
            <li v-if="isCC"><img :src="require('@/assets/images/detail/ico_badges_cc.png')" alt="cc 아이콘"></li>
            <li v-if="videoSpec"><img :src="require(`@/assets/images/detail/ico_badges_${videoSpec}.png`)" :alt="`${videoSpec} 아이콘`"></li>
          </ul>
        </div>

        <div class="comments">
          <ul>
            <template v-for="(comment, index) in comments">
              <li v-if="comment" :key="`comment_${index}`">{{ comment }}</li>
            </template>
          </ul>
        </div>

        <div v-if="!isPooqzone" class="optional-buttons">
          <IconBoxZzimWithApi section="vod" :content-id="contentId" :zzim="zzim"/>
          <IconBoxSnsShare :content-info="contentInfo" section="vod"/>
        </div>

        <div class="essential-buttons">
          <VodFilterList
            v-if="hasSeason"
            :current-season="contentId"
            :filter-item="seasonList"
            :base-api="seasonList.baseApi"
          />
          <PlayerActionButton
            :click-player-fn="clickPlayerFn"
            :content-info="contentInfo"
            :landing-info="landingInfo"
            :section="section"
          />
        </div>

        <div class="summary">
          <h2
            v-if="remainViewTime"
            class="sub-title"
          >
            <template v-if="episode.number">{{ episode.number }}. </template>
            {{ episode.title || '에피소드' }}
          </h2>
<!--       todo: content Status 를 보지 않고 remain view time 만으로 체크 해도 될지 체크 (22/12/16) v-if="contentsStatus === 'continue' && remainViewTime"-->
          <div
            v-if="contentsStatus === 'continue' && !isComingSoon"
            class="history"
          >
            <div class="progress">
              <span class="progress-meter" :style="`width: ${viewRatio}`">&nbsp;</span>
            </div>
            <span>{{ remainViewTime }}분 남음</span>
          </div>

          <button
            type="button"
            class="btn-synopsis"
            @click.prevent="moveToDetailInfo()"
          >
            <v-clamp :max-lines="3" ellipsis="..." >
              {{ renderSynopsis(synopsis) }}
              <template #after>
                <span class="view-more">더보기</span>
              </template>
            </v-clamp>
          </button>
          <p v-if="isShowActorList && !isComingSoon" class="cast">출연 :
            <span
              v-for="(actor, index) in actorList"
              :key="`actors_${index}`"
            >
              {{ actor.value }}{{actorList.length - 1 !== index ? ', ' : ''}}
            </span>
          </p>
        </div>
      </div>
    </div>

    <div v-if="hasNoticeList || hasEventList" class="outer-wrapper">
      <div class="inner-wrapper">
        <NoticeList
          v-if="hasNoticeList"
          :notice-list="noticeList"
        />

        <EventBannerList
          v-if="hasEventList"
          :event-banner-list="eventList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { topTagList } from '@/common/directives'
import IconBoxSnsShare from '@/components/play/IconBoxSnsShare'
import utils from '@/common/util/utils'
import PlayerActionButton from '@/components/play/PlayerActionButton'
import { get } from 'lodash'
import IconBoxZzimWithApi from '@/components/play/IconBoxZzimWithApi'
import { PATH_NAME_PLAYER_VOD_DETAIL_INFO } from '@/common/router.const'
import { getVideoSpec, getRemainViewTime, getDecodedHTMLText } from '@/common/util/player.util'
import VodFilterList from '@/components/section/template/VodFilterList'
import VClamp from 'vue-clamp'
import AgeGrade from '@/components/play/AgeGrade'
import EventBannerList from '@/components/play/EventBannerList'
import NoticeList from '@/components/play/NoticeList'

export default {
  name: 'VodPlayerDetailInfo',
  components: {
    NoticeList,
    EventBannerList,
    IconBoxZzimWithApi,
    IconBoxSnsShare,
    PlayerActionButton,
    VodFilterList,
    VClamp,
    AgeGrade
  },
  directives: {
    topTagList
  },
  props: {
    contentInfo: {
      type: Object,
      default: () => {}
    },
    clickPlayerFn: {
      type: Function
    },
    noticeList: {
      type: Array,
      default: null
    },
    eventList: {
      type: Array,
      default: null
    },
    landingInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isPooqzone: utils.cookies.isPooqZone()
    }
  },
  computed: {
    actorList () {
      return get(this.contentInfo, 'actors.list', [])
    },
    brandLogo () {
      const wavveLogo = ['original', 'only']
      const brandLogo = get(this.contentInfo, 'brand_logolist.0', '')
      return wavveLogo.includes(brandLogo) ? `wavve_${brandLogo}` : brandLogo
    },
    contentId () {
      return get(this.contentInfo, 'programid', '')
    },
    comments () {
      const { autocomment = '', comment = '' } = this.contentInfo
      return [ autocomment, comment ]
    },
    contentsStatus () {
      return get(this.landingInfo, 'contents_status', '')
    },
    episode () {
      const { episodenumber: episodeNumber = '', episodetitle: title = '', episodesynopsis: synopsis = '' } = this.contentInfo
      const number = episodeNumber.replace('회', '')
      return { number, title, synopsis }
    },
    kmrbCode () {
      const { kmrbcode } = this.contentInfo
      return kmrbcode ? 'movie' : 'vod'
    },
    metaData () {
      const { genretext: genreText = '', targetage: targetAge = '' } = this.contentInfo
      return { genreText, targetAge }
    },
    remainViewTime () {
      const { playtime = '0', viewtime = '0' } = this.contentInfo
      const hasViewTime = this.contentsStatus === 'continue'
      return hasViewTime ? getRemainViewTime(playtime, viewtime) : 0
    },
    seasonList () {
      const { season_list: seasonList = {} } = this.contentInfo
      const { count = '0', base_api: baseApi = '', season_item_list: seasonItemList = [] } = seasonList

      return { count, baseApi, seasonItemList }
    },
    season () {
      const { seasontitle: title = '', seasonsynopsis: synopsis } = this.contentInfo
      return { title, synopsis }
    },
    section () {
      const { type = '' } = this.contentInfo
      return type === 'general' ? 'vod' : 'qvod'
    },
    synopsis () {
      // contentid 로 조회 할 경우 content_status 에 continue 가 내려오지 않아 viewtime 체크 (e.g 홈 - 실시간 인기 콘텐츠 - 이미 시청 했을 경우, 콘텐츠 상세 - 플레이어 재생 - 뒤로가기 - 콘텐츠 상세(contentid 로 조회) 일 경우)
      return (this.contentsStatus === 'continue')
        ? (this.episode.synopsis || this.season.synopsis)
        : this.season.synopsis
    },
    viewRatio () {
      return `${Number(get(this.contentInfo, 'viewratio', '')) * 100}%`
    },
    videoSpec () {
      return getVideoSpec(this.contentInfo)
    },
    zzim () {
      return get(this.contentInfo, 'zzim', 'n').toLowerCase()
    },
    isComingSoon () {
      return this.contentsStatus === 'commingsoon'
    },
    isShowActorList () { // 시청이력이 없고, 로그아웃 되어 있을 경우 출연진 미노출
      // contentid 로 조회 할 경우 content_status 에 continue 가 내려오지 않아 viewtime 체크 (e.g 홈 - 실시간 인기 콘텐츠 - 이미 시청 했을 경우, 콘텐츠 상세 - 플레이어 재생 - 뒤로가기 - 콘텐츠 상세(contentid 로 조회) 일 경우)
      return this.hasActorList && (this.contentsStatus === 'continue' || this.remainViewTime > 0)
    },
    isCC () {
      return get(this.contentInfo, 'isCC', '').toLowerCase() === 'y'
    },
    hasEventList () {
      return this.eventList.length > 0
    },
    hasSeason () {
      return Number(this.seasonList.count) > 1
    },
    hasActorList () {
      return this.actorList.length > 0
    },
    hasNoticeList () {
      return (this.noticeList || []).length > 0
    }
  },
  methods: {
    moveToDetailInfo () {
      const { content_id: contentId = '' } = this.landingInfo
      const synopsis = (this.contentsStatus === 'continue' || this.remainViewTime > 0)
        ? 'episode'
        : 'season'

      this.$router.push({
        name: PATH_NAME_PLAYER_VOD_DETAIL_INFO,
        query: {
          contentid: contentId,
          synopsis: synopsis
        }
      })
    },
    renderSynopsis (synopsis) {
      return getDecodedHTMLText(synopsis)
    }
  }
}
</script>
